
  (function () {

    /* =========================================================
       ELEMENTI DEL CARRELLO
    ========================================================= */

    function getElements() {
      return {
        cartForm: document.getElementById('cart-form'),
        checkoutButton: document.getElementById('checkout'),
        inputField: document.getElementById('codice-fiscale'),
        errorSpan: document.getElementById('codice-fiscale-error')
      };
    }


    /* =========================================================
       NORMALIZZAZIONE CODICE FISCALE
    ========================================================= */

    function normalizeFiscalCode(value) {
      return String(value || '')
        .trim()
        .replace(/\s+/g, '')
        .toUpperCase();
    }


    /* =========================================================
       CONTROLLO DEL FORMATO
       
       Controlla:
       - 16 caratteri
       - struttura alfanumerica prevista
       - caratteri utilizzabili nelle posizioni di omocodia
    ========================================================= */

    function hasValidFiscalCodeFormat(fiscalCode) {
      var pattern =
        /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-EHLMPRST][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/;

      return pattern.test(fiscalCode);
    }


    /* =========================================================
       CONTROLLO DEL CARATTERE FINALE
    ========================================================= */

    function hasValidFiscalCodeChecksum(fiscalCode) {
      var oddValues = {
        '0': 1,
        '1': 0,
        '2': 5,
        '3': 7,
        '4': 9,
        '5': 13,
        '6': 15,
        '7': 17,
        '8': 19,
        '9': 21,

        'A': 1,
        'B': 0,
        'C': 5,
        'D': 7,
        'E': 9,
        'F': 13,
        'G': 15,
        'H': 17,
        'I': 19,
        'J': 21,
        'K': 2,
        'L': 4,
        'M': 18,
        'N': 20,
        'O': 11,
        'P': 3,
        'Q': 6,
        'R': 8,
        'S': 12,
        'T': 14,
        'U': 16,
        'V': 10,
        'W': 22,
        'X': 25,
        'Y': 24,
        'Z': 23
      };

      var evenValues = {
        '0': 0,
        '1': 1,
        '2': 2,
        '3': 3,
        '4': 4,
        '5': 5,
        '6': 6,
        '7': 7,
        '8': 8,
        '9': 9,

        'A': 0,
        'B': 1,
        'C': 2,
        'D': 3,
        'E': 4,
        'F': 5,
        'G': 6,
        'H': 7,
        'I': 8,
        'J': 9,
        'K': 10,
        'L': 11,
        'M': 12,
        'N': 13,
        'O': 14,
        'P': 15,
        'Q': 16,
        'R': 17,
        'S': 18,
        'T': 19,
        'U': 20,
        'V': 21,
        'W': 22,
        'X': 23,
        'Y': 24,
        'Z': 25
      };

      var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var total = 0;

      for (var i = 0; i < 15; i++) {
        var character = fiscalCode.charAt(i);

        if (i % 2 === 0) {
          total += oddValues[character];
        } else {
          total += evenValues[character];
        }
      }

      var expectedControlCharacter =
        alphabet.charAt(total % 26);

      var actualControlCharacter =
        fiscalCode.charAt(15);

      return (
        expectedControlCharacter ===
        actualControlCharacter
      );
    }


    /* =========================================================
       VALIDAZIONE COMPLETA
    ========================================================= */

    function isFiscalCodeValid() {
      var elements = getElements();

      if (!elements.inputField) {
        return false;
      }

      var fiscalCode =
        normalizeFiscalCode(
          elements.inputField.value
        );

      /* Salva nel campo il valore normalizzato */
      elements.inputField.value = fiscalCode;

      /* Il Codice Fiscale deve avere 16 caratteri */
      if (fiscalCode.length !== 16) {
        return false;
      }

      /* Controllo della struttura */
      if (!hasValidFiscalCodeFormat(fiscalCode)) {
        return false;
      }

      /* Controllo della lettera finale */
      if (!hasValidFiscalCodeChecksum(fiscalCode)) {
        return false;
      }

      return true;
    }


    /* =========================================================
       VISUALIZZAZIONE ERRORE
    ========================================================= */

    function showFiscalCodeError(
      inputField,
      errorSpan
    ) {
      if (errorSpan) {
        errorSpan.textContent =
          'Inserisci un Codice Fiscale valido.';

        errorSpan.style.display = 'block';
      }

      if (inputField) {
        inputField.classList.add(
          'cart-attribute-field__input--error'
        );

        inputField.setAttribute(
          'aria-invalid',
          'true'
        );

        inputField.focus();
      }
    }


    /* =========================================================
       RIMOZIONE ERRORE
    ========================================================= */

    function hideFiscalCodeError(
      inputField,
      errorSpan
    ) {
      if (errorSpan) {
        errorSpan.style.display = 'none';
      }

      if (inputField) {
        inputField.classList.remove(
          'cart-attribute-field__input--error'
        );

        inputField.removeAttribute(
          'aria-invalid'
        );
      }
    }


    /* =========================================================
       VALIDAZIONE PRIMA DEL CHECKOUT
    ========================================================= */

    function validateFiscalCode(event) {
      var elements = getElements();

      if (
        !elements.inputField ||
        !elements.errorSpan
      ) {
        return;
      }

      if (!isFiscalCodeValid()) {

        if (event) {
          event.preventDefault();
          event.stopPropagation();

          if (
            typeof event.stopImmediatePropagation ===
            'function'
          ) {
            event.stopImmediatePropagation();
          }
        }

        showFiscalCodeError(
          elements.inputField,
          elements.errorSpan
        );

        return false;
      }

      hideFiscalCodeError(
        elements.inputField,
        elements.errorSpan
      );

      return true;
    }


    /* =========================================================
       CLICK SUL BOTTONE CHECKOUT
    ========================================================= */

    document.addEventListener(
      'click',
      function (event) {
        var checkoutButton =
          event.target.closest(
            '#checkout, button[name="checkout"], input[name="checkout"]'
          );

        if (!checkoutButton) {
          return;
        }

        validateFiscalCode(event);
      },
      true
    );


    /* =========================================================
       INVIO DEL FORM DEL CARRELLO
    ========================================================= */

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;

        if (!form) {
          return;
        }

        var isCartForm =
          form.id === 'cart-form' ||
          form.getAttribute('action') === '/cart' ||
          form.getAttribute('action') === '/cart?';

        if (!isCartForm) {
          return;
        }

        validateFiscalCode(event);
      },
      true
    );


    /* =========================================================
       CONTROLLO DURANTE LA DIGITAZIONE
    ========================================================= */

    document.addEventListener(
      'input',
      function (event) {
        if (
          !event.target.matches(
            '#codice-fiscale'
          )
        ) {
          return;
        }

        var elements = getElements();

        var normalizedValue =
          normalizeFiscalCode(
            event.target.value
          );

        /*
         * Trasforma automaticamente il testo
         * in maiuscolo e rimuove eventuali spazi.
         */
        if (
          event.target.value !==
          normalizedValue
        ) {
          event.target.value =
            normalizedValue;
        }

        /*
         * Durante la modifica rimuove l'errore.
         * Il controllo completo viene effettuato
         * quando l'utente lascia il campo
         * oppure procede al checkout.
         */
        hideFiscalCodeError(
          elements.inputField,
          elements.errorSpan
        );
      }
    );


    /* =========================================================
       CONTROLLO QUANDO SI ESCE DAL CAMPO
    ========================================================= */

    document.addEventListener(
      'blur',
      function (event) {
        if (
          !event.target.matches(
            '#codice-fiscale'
          )
        ) {
          return;
        }

        var elements = getElements();

        /*
         * Se il campo è ancora vuoto non mostriamo
         * immediatamente l'errore.
         * Rimane comunque obbligatorio al checkout.
         */
        if (!event.target.value.trim()) {
          return;
        }

        if (!isFiscalCodeValid()) {
          showFiscalCodeError(
            elements.inputField,
            elements.errorSpan
          );
        } else {
          hideFiscalCodeError(
            elements.inputField,
            elements.errorSpan
          );
        }
      },
      true
    );

  })();
